"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lvZones = void 0;
var lvZones = exports.lvZones = [{
  id: 'RIGA',
  name: 'Riga',
  country: 'LV',
  cornerNW: {
    latitude: 57.0859,
    longitude: 23.9111
  },
  cornerSE: {
    latitude: 56.8333,
    longitude: 24.3075
  },
  subZones: [{
    name: 'Riga Centre historique',
    zipcodes: {
      'LV-1010': {
        label: 'LV-1010'
      }
    }
  }, {
    name: 'Riga Vecā Rīga',
    zipcodes: {
      'LV-1011': {
        label: 'LV-1011'
      }
    }
  }, {
    name: 'Riga Jūgendstila kvartāls',
    zipcodes: {
      'LV-1024': {
        label: 'LV-1024'
      }
    }
  }, {
    name: 'Riga Biznesa rajons',
    zipcodes: {
      'LV-1063': {
        label: 'LV-1063'
      }
    }
  }]
}];